import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../supabaseClient";
import Header from "../components/Header";

const STATUS_BADGE = {
  pending:  "bg-[#ffd978]/15 text-[#ffd978] border-[#ffd978]/30",
  accepted: "bg-green-500/15 text-green-400 border-green-500/30",
  denied:   "bg-red-500/15 text-red-400 border-red-500/30",
};

export default function AppealsReview() {
  const [appeals, setAppeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    loadAppeals();
  }, []);

  async function loadAppeals() {
    setLoading(true);
    const { data } = await supabase
      .from("ban_appeals")
      .select("id, discord_username, roblox_username, status, created_at")
      .order("created_at", { ascending: false });

    setAppeals(data || []);
    setLoading(false);
  }

  const filtered = filter === "all" ? appeals : appeals.filter(a => a.status === filter);
  const counts = {
    all: appeals.length,
    pending: appeals.filter(a => a.status === "pending").length,
    accepted: appeals.filter(a => a.status === "accepted").length,
    denied: appeals.filter(a => a.status === "denied").length,
  };

  return (
    <main className="min-h-screen bg-[#050505] text-white">
      <Header />

      <section className="px-6 pt-36 pb-20 md:px-[7%]">
        <p className="font-black uppercase text-[#ffb56f]">Admin</p>
        <h1 className="outfall-heading text-[clamp(58px,9vw,120px)] leading-none text-[#ffd978] drop-shadow-[0_0_18px_#ff8f6b]">
          Appeals
        </h1>

        {/* Filter tabs */}
        <div className="mt-8 flex flex-wrap gap-2">
          {[["all","All"], ["pending","Pending"], ["accepted","Accepted"], ["denied","Denied"]].map(([key, label]) => (
            <button
              key={key}
              onClick={() => setFilter(key)}
              className={`rounded-full px-5 py-2 font-black uppercase text-sm transition ${
                filter === key
                  ? "bg-[#ffd978] text-black"
                  : "border border-[#ffd978]/30 text-white/50 hover:text-white"
              }`}
            >
              {label} <span className="opacity-60">({counts[key]})</span>
            </button>
          ))}
        </div>

        <div className="mt-6 overflow-hidden rounded-[24px] border-4 border-[#ffd978] bg-black/60 shadow-[0_0_35px_rgba(255,143,107,0.35)]">
          {loading ? (
            <p className="p-6 font-black text-xl">Loading appeals...</p>
          ) : filtered.length === 0 ? (
            <p className="p-6 font-black text-xl">No appeals found.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[700px] border-collapse">
                <thead className="bg-[#ffd978] text-black">
                  <tr>
                    <th className="px-5 py-4 text-left font-black uppercase">Discord</th>
                    <th className="px-5 py-4 text-left font-black uppercase">Roblox</th>
                    <th className="px-5 py-4 text-left font-black uppercase">Status</th>
                    <th className="px-5 py-4 text-left font-black uppercase">Submitted</th>
                    <th className="px-5 py-4 text-left font-black uppercase">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((appeal) => (
                    <tr key={appeal.id} className="border-t border-[#ffb56f]/20 hover:bg-white/5">
                      <td className="px-5 py-4 font-black text-white">
                        {appeal.discord_username || "—"}
                      </td>
                      <td className="px-5 py-4 font-bold text-white">
                        {appeal.roblox_username}
                      </td>
                      <td className="px-5 py-4">
                        <span className={`rounded-full border px-3 py-1 text-sm font-black uppercase ${STATUS_BADGE[appeal.status] || STATUS_BADGE.pending}`}>
                          {appeal.status}
                        </span>
                      </td>
                      <td className="px-5 py-4 font-bold text-white/50">
                        {new Date(appeal.created_at).toLocaleString()}
                      </td>
                      <td className="px-5 py-4">
                        <Link to={`/appeals-review/${appeal.id}`} className="outfall-button">
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
